import { defineMessages } from "react-intl";

export default defineMessages({
  "identityVerificationModal.title": {
    id: "identityVerificationModal.title",
    defaultMessage: "Verification will be enforced very soon",
  },
  "identityVerificationModal.subtitle": {
    id: "identityVerificationModal.subtitle",
    defaultMessage: "Get your badge now!",
  },
  "identityVerificationModal.reminder": {
    id: "identityVerificationModal.reminder",
    defaultMessage: "Reminder: have your ID at hand",
  },
  "identityVerificationModal.remindMeLater": {
    id: "identityVerificationModal.remindMeLater",
    defaultMessage: "Remind me later",
  },
  "identityVerificationModal.verifyMe": {
    id: "identityVerificationModal.verifyMe",
    defaultMessage: "Verify me!",
  },
});
